function getNWords(str, numWordsToCount) {
    const allWordMatches = Array.from(str.matchAll(/\[([^\]]+)\]\(([^)]+)\)|[^\s\|\-]+/g));
    const targetWords = allWordMatches.slice(0, numWordsToCount);
    const endIndex = numWordsToCount > allWordMatches.length
        ? str.length
        : targetWords.length ? targetWords.at(-1).index + targetWords.at(-1)[0].length : 0;
    const value = str.substring(0, endIndex);
    return {
        value,
        actualWordCount: targetWords.length === 0 ? (value.length ? 1 : 0) : targetWords.length,
        isFullString: endIndex >= str.length
    };
}
function countWords(str) {
    const result = getNWords(str, Number.MAX_SAFE_INTEGER);
    return result.actualWordCount;
}
export { countWords, getNWords };
